import type { FC } from "react";
import { MultipleContactPersonInputBase } from "../../shared/MultipleContactPersonInputBase";
import type { InputProps } from "../../DynamicInput";
import type { MultipleContactPersonValue } from "../../types";

export const MultipleContactPersonInput: FC<InputProps<MultipleContactPersonValue>> = props => {
  return <MultipleContactPersonInputBase {...props} isMultistepFormVersion={false} />;
};
